import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '../store/authStore';
import { getCompanyOverview } from '../api/company';
import { geocodePostcode } from '../lib/geocode';
import { queryKeys } from '../api/queryKeys';

export const LONDON_CENTRE: [number, number] = [51.5074, -0.1278];

/**
 * Resolves the map centre for the authenticated company's postcode.
 * Falls back to London if the postcode is missing or cannot be geocoded.
 * Result is cached for the session (staleTime: Infinity).
 */
export function useMapCentre(): [number, number] {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  const { data } = useQuery({
    queryKey: queryKeys.company.mapCentre,
    queryFn: async () => {
      const overview = await getCompanyOverview();
      const coords = await geocodePostcode(overview.company.postcode);
      return coords ?? LONDON_CENTRE;
    },
    enabled: isAuthenticated,
    staleTime: Infinity, // postcode doesn't change during a session
    gcTime: Infinity,
    retry: 1,
  });

  return data ?? LONDON_CENTRE;
}
